export const CONSTRUCT_MESSAGE_PROP_VALUE = {
  type: 'FUNCTION',
  passReference: true,
  value: {
    name: 'createDefaultMessageFromState',
    requires: '@bluefin/components',
    importType: 'OBJECT',
  },
};
